import { ExportedInstructionWrapper } from 'src/Containers/Exports/ExportPage/ExportInstructionPage/ExportedInstructionWrapper';
import useFetchExport from 'src/Hooks/Queries/useFetchExport';

import { Props } from './ExportInstructionPage.types';

const ExportInstructionPage = ({ token }: Props) => {
  const { data } = useFetchExport(token);
  return (
    data?.entityIds?.[0] && (
      <ExportedInstructionWrapper token={token} instructionId={data.entityIds[0]} />
    )
  );
};

export default ExportInstructionPage;
